export enum enumTransactionType {
  'Withdrawal' = 1,
  'Balance Enquiry',
  'Cellular Prepaid'
}

export namespace enumTransactionType {
  export function values() {
    return Object.keys(enumTransactionType).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
